import React from "react";
import { PageSettings } from "./../config/page-settings.js";
import { Api } from "../app-controller.js";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { useAuth } from "../components/content/auth.jsx";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.validarLicenciaRegente = this.validarLicenciaRegente.bind(this);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }
  }

  static contextType = PageSettings;
  componentDidMount() {
    this.validarLicenciaRegente();

    this.context.handleSetPageSidebar(true);
    this.context.handleSetPageHeader(true);
    if (localStorage.nivel_actual === "1") {
      let invObj = {
        source: "app/getInvitation",
        target: "#invitaciones",
        buttonArea: "100px",
        //hideonempty:true,
        titulo: "Invitaciones para regente",
        tableClass: "table  table-striped m-b-0 table-hover",
        noResults: "Sin invitaciones para regentes.",
        hidePager: 1,
        rowsPerPage: [5, 10, 25, 50, 100],
        progressText: "Buscando invitaciones para regente",
        rows: {
          razon_social: {
            label: "Establecimiento",
          },
          fecha: {
            label: "Fecha solicitud",
          },
        },
        buttons: [
          {
            btnClass: "btn bg-gradient-red",
            iconClass: "fas fa-times",
            btnClick: (data) => {
              Swal.fire({
                title: "¿Rechazar invitación?",
                text: data.razon_social,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Regresar",
                confirmButtonColor: "#4CD964",
                cancelButtonColor: "red",
                reverseButtons: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  Api.loading(true);
                  Api.fetch(
                    "app/setInvitationStatus",
                    {
                      id: data.id,
                      solid: data.solicitud_id,
                      status: 0,
                    },
                    "POST"
                  ).then((r) => {
                    Api.loading(false);
                    invitaciones.go(1);
                  });
                }
              });
            },
            render: () => {},
          },
          {
            iconClass: "fas fa-check",
            btnClass: "btn bg-gradient-green",
            btnClick: (data) => {
              Swal.fire({
                title: "¿Aceptar invitación?",
                text: data.razon_social,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Regresar",
                confirmButtonColor: "#4CD964",
                cancelButtonColor: "red",
                reverseButtons: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  Api.loading(true);
                  Api.fetch(
                    "app/setInvitationStatus",
                    {
                      id: data.id,
                      solid: data.solicitud_id,
                      status: 1,
                    },
                    "POST"
                  ).then((r) => {
                    Api.loading(false);
                    invitaciones.go(1);
                  });
                }
              });
            },
            render: () => {},
          },
        ],
      };

      let invitaciones = Api.grid(invObj);
      let relOBJ = { ...invObj };
      relOBJ.source = "app/getIRelacion";
      relOBJ.target = "#relEstablecimientos";
      relOBJ.titulo = "Invitaciones de asociación a establecimientos";
      relOBJ.noResults = "Sin invitaciones para establecimientos";
      relOBJ.rows = {
        razon_social: {
          label: "Establecimiento",
        },
        fecha: {
          label: "Fecha solicitud",
        },
      };
      relOBJ.buttons = [
        {
          iconClass: "fas fa-times",
          btnClass: "btn bg-gradient-red",
          btnClick: (data) => {
            Swal.fire({
              title: "¿Rechazar invitación?",
              text: data.razon_social,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Aceptar",
              cancelButtonText: "Regresar",
              confirmButtonColor: "#4CD964",
              cancelButtonColor: "red",
              reverseButtons: true,
            }).then((result) => {
              if (result.isConfirmed) {
                Api.loading(true);
                Api.fetch(
                  "app/setInvitationRelStatus",
                  {
                    id: data.id,
                    relid: data.relid,
                    status: null,
                  },
                  "POST"
                ).then((r) => {
                  Api.loading(false);
                  InvRelaciones.go(1);
                });
              }
            });
          },
          render: () => {},
        },
        {
          iconClass: "fas fa-check",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            Swal.fire({
              title: "¿Aceptar invitación?",
              text: data.razon_social,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Aceptar",
              cancelButtonText: "Regresar",
              confirmButtonColor: "#4CD964",
              cancelButtonColor: "red",
              reverseButtons: true,
            }).then((result) => {
              if (result.isConfirmed) {
                Api.loading(true);
                Api.fetch(
                  "app/setInvitationRelStatus",
                  {
                    id: data.id,
                    relid: data.relid,
                    status: 1,
                  },
                  "POST"
                ).then((r) => {
                  Api.loading(false);
                  InvRelaciones.go(1);
                });
              }
            });
          },
          render: () => {},
        },
      ];
      relOBJ.progressText = "Buscando invitaciones de establecimientos";
      let InvRelaciones = Api.grid(relOBJ);

      // movimiento de productos
      let relSolMov = { ...invObj };
      relSolMov.source = "app/getIMoveProductRequest";
      relSolMov.target = "#invitacionMovimientoProducto";
      relSolMov.titulo = "Invitaciones de movimientos de productos";
      relSolMov.noResults = "Sin invitaciones para movimiento de productos";
      relSolMov.rows = {
        razon_social: {
          label: "Establecimiento",
        },
        fecha: {
          label: "Fecha solicitud",
        },
      };
      relSolMov.buttons = [
        {
          iconClass: "fas fa-times",
          btnClass: "btn bg-gradient-red",
          btnClick: (data) => {
            Swal.fire({
              title: "¿Rechazar invitación?",
              text: data.razon_social,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Aceptar",
              cancelButtonText: "Regresar",
              confirmButtonColor: "#4CD964",
              cancelButtonColor: "red",
              reverseButtons: true,
            }).then((result) => {
              if (result.isConfirmed) {
                Api.loading(true);
                Api.fetch(
                  "app/setMoveProductRequestStatus",
                  {
                    id: data.establecimiento_id,
                    razon_social: data.razon_social,
                    establecimiento_recibe_id: data.establecimiento_recibe_id,
                    bitacora_id: data.id,
                    status: 0,
                    solicitud_id: data.solicitud_id,
                  },
                  "POST"
                ).then((r) => {
                  Api.loading(false);
                  InvSolMov.go(1);
                });
              }
            });
          },
          render: () => {},
        },
        {
          iconClass: "fas fa-check",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            Swal.fire({
              title: "¿Aceptar invitación?",
              text: data.razon_social,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Aceptar",
              confirmButtonColor: "#4CD964",
              cancelButtonText: "Regresar",
              cancelButtonColor: "red",
              reverseButtons: true,
            }).then((result) => {
              if (result.isConfirmed) {
                Api.loading(true);
                Api.fetch(
                  "app/setMoveProductRequestStatus",
                  {
                    id: data.establecimiento_id,
                    razon_social: data.razon_social,
                    establecimiento_recibe_id: data.establecimiento_recibe_id,
                    bitacora_id: data.id,
                    status: 1,
                    solicitud_id: data.solicitud_id,
                  },
                  "POST"
                ).then((r) => {
                  Api.loading(false);
                  InvSolMov.go(1);
                });
              }
            });
          },
          render: () => {},
        },
      ];
      relSolMov.progressText =
        "Buscando invitaciones para movimientos de productos";
      let InvSolMov = Api.grid(relSolMov);
    }
  }

  validarLicenciaRegente() {
    Api.fetch("app/validarLicenciasUsuario").then((r) => {});
  }

  render() {
    return (
      <div className="row">
        <div
          className={
            localStorage.nivel_actual === "1" ? "  col-lg-4" : "hidden"
          }
          id="invitaciones"
        ></div>
        <div
          className={
            localStorage.nivel_actual === "1" ? "  col-lg-4" : "hidden"
          }
          id="relEstablecimientos"
        ></div>
        <div
          className={
            localStorage.nivel_actual === "1" ? "  col-lg-4" : "hidden"
          }
          id="invitacionMovimientoProducto"
        ></div>

        <div className="col-sm-12">
          <a
            href=""
            className="widget-card widget-card-rounded m-b-10"
            style={{
              height: "40rem",
            }}
            data-id="widget"
          >
            <div
              className="widget-card-cover"
              style={{
                backgroundColor: "#333",
                backgroundImage: "url('../assets/pexels-photo-5275154.jpeg')",
              }}
            ></div>
            <div className="widget-card-content">
              <h1
                style={{
                  paddingTop: "7rem",
                }}
                className=" display-4 text-white text-center m-t-10 home-welcome-text"
              >
                <b>
                  BIENVENIDO
                  <br />
                </b>
              </h1>
            </div>
            <div className="widget-card-content bottom">
              {/*  								<img  src="../assets/logo_1.png" style={{width:"10%",height:"10%"}} 
 * ></img><b></b>

 */}
              <h3 className=" text-white-transparent-9 m-t-20 text-justify home-text">
                <b>
                  El Sistema Integral Nacional de Insumos Pecuarios (SINAIP) es
                  un sistema que facilita la colecta, armonización,
                  procesamiento y consulta de los registros generados a través
                  de los servicios y acciones que presta IPSA en el ámbito de
                  los insumos pecuarios y establecimientos que los comercializan
                  o manejan.
                </b>
              </h3>
              {/*  									<h5 className="f-s-12 text-white-transparent-7 m-b-2"><b>EASILY DRA
 * W ON PHOTOS</b></h5>

 */}
            </div>
          </a>
        </div>

        {/* <div className="card bg-dark text-white">
							<img className="card-img" src="../assets/pexels-photo-3470482.jpeg" alt="Card image"></img>
							<div className="card-img-overlay">
							<h2 className="card-title">Bienvenido</h2>
								<h4 className="card-text f-s-13">El Sistema Integral Nacional de Insumos Pecuarios (SINAIP) es un sistema que facilita la colecta, armonización, procesamiento y consulta de los registros generados a través de los servicios y acciones que presta IPSA en el ámbito de los insumos pecuarios y establecimientos que los comercializan o manejan.</h4>
								<p className="card-text text-grayf-s-13">Last updated 3 mins ago</p>
							</div>
							</div> */}
      </div>
    );
  }
}

//export default Home;

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <Home auth={auth} history={history} {...props} />;
};
